import clsx from "clsx";
import { useEffect } from "react";
import { useMutation } from "react-query";
import { getProfileImg } from "../../../../api";
import { APP_URLs } from "../../../../constants/appURLs";
import { HeaderUserMenu } from "../../../partials";
import { useLayout } from "../../core";

const itemClass = "ms-1 ms-lg-3";
const btnClass =
  "btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px";
const userAvatarClass = "symbol-35px symbol-md-40px";
const btnIconClass = "fs-1";

const isValidString = (val: any): val is string => {
  return (
    typeof val === "string" &&
    val.trim().length > 0 &&
    val.trim().toLowerCase() !== "undefined" &&
    val.trim().toLowerCase() !== "null"
  );
};

const Navbar = () => {
  const { config } = useLayout();

  const { mutateAsync: getUserProfileImg, data: userProfile } =
    useMutation(getProfileImg);

  useEffect(() => {
    getUserProfileImg();
  }, []);

  let storedUserInfo: any = null;
  try {
    const raw = localStorage.getItem("userInfo");
    if (raw) {
      storedUserInfo = JSON.parse(raw);
    }
  } catch (e) {
    console.error("Failed to parse userInfo from localStorage", e);
  }

  const userProfileImg = isValidString(userProfile?.result?.profileUrl)
    ? userProfile.result.profileUrl
    : isValidString(storedUserInfo?.profileUrl)
    ? storedUserInfo.profileUrl
    : null;
  const userImage = userProfileImg
    ? `${APP_URLs?.mediaBaseURL}${userProfileImg}`
    : "";

  const firstName = isValidString(userProfile?.result?.firstName)
    ? userProfile.result.firstName.trim()
    : isValidString(storedUserInfo?.firstName)
    ? storedUserInfo.firstName.trim()
    : "";

  const lastName = isValidString(userProfile?.result?.lastName)
    ? userProfile.result.lastName.trim()
    : isValidString(storedUserInfo?.lastName)
    ? storedUserInfo.lastName.trim()
    : "";

  const roleOrName = isValidString(storedUserInfo?.roleName)
    ? storedUserInfo.roleName.trim()
    : isValidString(storedUserInfo?.userName || storedUserInfo?.username)
    ? (storedUserInfo.userName || storedUserInfo.username).trim()
    : isValidString(storedUserInfo?.name)
    ? storedUserInfo.name.trim()
    : "";

  let displayName = "User";
  if (firstName && lastName) {
    displayName = `${firstName} ${lastName}`;
  } else if (firstName) {
    displayName = firstName;
  } else if (lastName) {
    displayName = lastName;
  } else if (roleOrName) {
    displayName = roleOrName;
  }

  let initials = "U";
  if (firstName && lastName) {
    initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  } else if (firstName) {
    initials = firstName.charAt(0).toUpperCase();
  } else if (lastName) {
    initials = lastName.charAt(0).toUpperCase();
  } else if (roleOrName) {
    initials = roleOrName.charAt(0).toUpperCase();
  }

  return (
    <div className="app-navbar flex-shrink-0">
      {/* <div className={clsx("app-navbar-item align-items-stretch", itemClass)}>
        <Search />
      </div> */}

      {/* <div className={clsx("app-navbar-item", itemClass)}>
        <div id="kt_activities_toggle" className={btnClass}>
          <KTIcon iconName="chart-simple" className={btnIconClass} />
        </div>
      </div> */}

      {/* <div className={clsx("app-navbar-item", itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
          className={btnClass}
        >
          <KTIcon iconName="element-plus" className={btnIconClass} />
        </div>
        <HeaderNotificationsMenu />
      </div> */}

      {/* <div className={clsx("app-navbar-item", itemClass)}>
        <div
          className={clsx("position-relative", btnClass)}
          id="kt_drawer_chat_toggle"
        >
          <KTIcon iconName="message-text-2" className={btnIconClass} />
          <span className="bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink" />
        </div>
      </div> */}

      {/* <div className={clsx("app-navbar-item", itemClass)}>
        <ThemeModeSwitcher
          toggleBtnClass={clsx("btn-active-light-primary btn-custom")}
        />
      </div> */}
      <div className={clsx("app-navbar-item", itemClass)}>
        <span className="fw-bold fs-6 text-gray-800 ms-1 ms-md-4 text-nowrap">
          Welcome, {displayName}
        </span>
      </div>
      <div className={clsx("app-navbar-item", itemClass)}>
        <div
          className={clsx(
            "cursor-pointer symbol symbol-circle",
            userAvatarClass,
          )}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
        >
          {userProfileImg ? (
            <img
              src={`${userImage}`}
              alt={displayName}
              style={{
                height: "50px",
                width: "50px",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          ) : (
            <div
              style={{
                height: "50px",
                width: "50px",
                borderRadius: "50%",
                backgroundColor: "#ccc",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textTransform: "uppercase",
                fontWeight: 600,
                fontSize: "16px",
                color: "#333",
                overflow: "hidden",
                whiteSpace: "nowrap",
                userSelect: "none",
              }}
            >
              {initials}
            </div>
          )}
        </div>
        <HeaderUserMenu userProfile={userProfile} />
      </div>

      {/* {config.app?.header?.default?.menu?.display && (
        <div
          className="app-navbar-item d-lg-none ms-2 me-n3"
          title="Show header menu"
        >
          <div
            className="btn btn-icon btn-active-color-primary w-35px h-35px"
            id="kt_app_header_menu_toggle"
          >
            <KTIcon iconName="text-align-left" className={btnIconClass} />
          </div>
        </div>
      )} */}
    </div>
  );
};

export { Navbar };
